import { render, staticRenderFns } from "./addOrg.vue?vue&type=template&id=70739278&"
import script from "./addOrg.vue?vue&type=script&lang=ts&"
export * from "./addOrg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports